import './highcharts';
import 'highcharts/es-modules/masters/modules/histogram-bellcurve.src.js';
import { Chart } from './Chart';
import type { ChartProps } from './Chart';

/**
 * Loads the Highcharts histogram-bellcurve module before rendering the shared
 * Seeq chart wrapper.
 */
export const HistogramBellCurveChart = ({ onReady, options, ...rest }: ChartProps) => {
  return <Chart {...rest} options={options} onReady={onReady} />;
};
